import { Box, HStack, Link, Text, VStack } from "@chakra-ui/react"
import { Link as RouterLink } from "react-router-dom"
import type { ResortDetailData } from "../../../hooks/useResort"
import ResortStatsTable from "../components/ResortStatsTable"

type ResortInfoTabProps = {
  data: ResortDetailData
}

export default function ResortInfoTab({ data }: ResortInfoTabProps) {
  const formattedRunLength =
    data.totalRunLengthMeters != null ? `${Math.round((data.totalRunLengthMeters / 1000) * 10) / 10} km` : "N/A"
  const rows = [
    { label: "Lift count", value: `${data.liftCount}` },
    { label: "Trail count", value: `${data.runCount}` },
    { label: "Total trail length", value: formattedRunLength },
  ]

  return (
    <VStack align="stretch" gap="6">
      <ResortStatsTable rows={rows} />

      {data.isGroup ? (
        <Box>
          <HStack justify="space-between" align="center" mb="3">
            <Text fontWeight="semibold">Group members</Text>
            <Text fontSize="sm" color="gray.400">
              {data.members?.length ?? 0} resorts
            </Text>
          </HStack>
          {data.members && data.members.length > 0 ? (
            <VStack align="start" gap="2">
              {data.members.map((member) => (
                <Link
                  key={member.uid}
                  asChild
                  color="blue.200"
                  _hover={{ textDecoration: "underline" }}
                >
                  <RouterLink to={`/resorts/${member.uid}`}>
                    {member.name || member.uid}
                  </RouterLink>
                </Link>
              ))}
            </VStack>
          ) : (
            <Text color="gray.400" fontSize="sm">
              No member resorts configured for this group.
            </Text>
          )}
        </Box>
      ) : (
        <Box>
          <Text fontWeight="semibold" mb="2">
            Group membership
          </Text>
          <Text color="gray.400" fontSize="sm">
            This resort is not configured as a group.
          </Text>
        </Box>
      )}
    </VStack>
  )
}
